import React, { useEffect, useRef, useState } from "react";
import { auth, provider, db } from "./firebase";
import { signInWithPopup } from "firebase/auth";
import { useSearchParams } from "react-router";
import { useAuthState } from "react-firebase-hooks/auth";
import {
    orderBy,
    where,
    getDocs,
    doc,
    setDoc,
    serverTimestamp,
    collection,
    query,
} from "firebase/firestore";
import footerImg from "./img/Mask group.png";
import headerImg from "./img/header-omgeving-pretpark.jpg";
import Voting from "./pages/Voting";

// Add global styles for Roboto font
const globalStyles = {
    fontFamily: "'Roboto', sans-serif",
    margin: 0,
    padding: 0,
};

function App() {
    const [user] = useAuthState(auth);
    const [searchParams] = useSearchParams();
    const [queryParam, setQueryParam] = useState(searchParams.get("q") ?? "0");
const [tempCode, setTempCode] = useState("");

    useEffect(() => {
        let collectedData = [
            { votes: ["vliegende hollander", "baron", "droomvlucht"] },
            { votes: ["vliegende hollander", "baron", "dance macabre"] },
            { votes: ["baron", "villa volta", "vliegende hollander"] },
            { votes: ["baron", "droomvlucht", "villa volta"] }
        ];

        function countFirstChoiceVotes(ballots) {
            let voteCounts = {};
            ballots.forEach(ballot => {
                const firstChoice = ballot.votes.find(vote => vote); // Find first valid vote
                if (firstChoice) {
                    voteCounts[firstChoice] = (voteCounts[firstChoice] || 0) + 1;
                }
            });
            return voteCounts;
        }

        function redistributeVotes(ballots, eliminatedRide) {
            return ballots.map(ballot => ({
                votes: ballot.votes.filter(vote => vote !== eliminatedRide) // Remove eliminated ride
            }));
        }

        function stv(ballots, seats) {
            let winners = [];

            while (winners.length < seats && ballots.length > 0) {
                let voteCounts = countFirstChoiceVotes(ballots);
                let sortedVotes = Object.entries(voteCounts).sort((a, b) => b[1] - a[1]);

                if (sortedVotes.length === 0) break; // No more valid votes left

                let mostVotedRide = sortedVotes[0][0];
                winners.push(mostVotedRide);

                // Remove selected ride from all ballots & redistribute votes
                ballots = redistributeVotes(ballots, mostVotedRide);

                // Remove empty ballots
                ballots = ballots.filter(ballot => ballot.votes.length > 0);
            }

            return winners;
        }

        let top3 = stv(collectedData, 3);
        console.log("Top 3 Attractions:", top3);
    }, []);




    return (
        <div id="container">
            <div id="headerSection" style={{ backgroundImage: `url(${headerImg})` }}></div>

            <div id="footerSection">
                {user ? (
                    <VoteScreen queryParam={queryParam} />
                ) : (
                    <SignIn queryParam={queryParam} setTempCode={setTempCode} setQueryParm={setQueryParam}/>
                )}
            </div>
        </div>
    );
}

function SignIn({ queryParam, setQueryParm }) {
    const [code, setCode] = useState(["", "", "", ""]);
    const inputsRef = useRef([]);


    useEffect(() => {
        if (queryParam && queryParam.length === 4) {
            setCode(queryParam.split(""));
        }
    }, [queryParam]);

    const signInWithGoogle = async () => {
        try {
            const codeString = code.join("");
            setQueryParm(codeString);
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error("Error signing in:", error);
        }
    };

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (!/^\d?$/.test(value)) return; // Allow only single digits

        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        if (value && index < 3) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (code[index]) {
                const newCode = [...code];
                newCode[index] = "";
                setCode(newCode);
            } else if (index > 0) {
                inputsRef.current[index - 1]?.focus();
            }
        }
    };

    return (
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
            <h1>Welkom bij Trackless</h1>
            <p id="h1Footer">Vul de code uit de Trackless app in om door te gaan.</p>
            <div id="codeInput" style={{ display: "flex", gap: "10px" }}>
                {code.map((digit, index) => (
                    <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputsRef.current[index] = el)}
                        style={{
                            width: "40px",
                            height: "40px",
                            fontSize: "20px",
                            textAlign: "center",
                        }}
                    />
                ))}
            </div>
            <button style={{position: "absolute", bottom: "20px"}} className="button" onClick={signInWithGoogle}>
                Inloggen met Google
            </button>
        </div>
    );
}


export function SignOut() {
    return auth.currentUser && <button style={{}} onClick={() => auth.signOut()}>Uitloggen</button>;
}

function VoteScreen({ queryParam }) {
    const [hasVoted, setHasVoted] = useState(null);

    useEffect(() => {

        const checkUserVote = async () => {
            const votesRef = collection(db, "votes");
            const q = query(
                votesRef,
                where("session", "==", queryParam),
                where("person", "==", auth.currentUser.uid)
            );
            const querySnapshot = await getDocs(q);
            setHasVoted(!querySnapshot.empty);
        };

        checkUserVote();
    }, [queryParam]);

    useEffect(() => {
        const footer = document.getElementById("footerSection");
        const header = document.getElementById("headerSection");
        if (footer && header) {
            footer.classList.add("active");
            header.classList.add("active");
        }
    }, []);

    if (hasVoted === null) return <p></p>;

    return (
        <div id="votePage" style={{height: "90vh", position: "relative"}}>
            {hasVoted ? (
                <div>
                <p>U heeft al een inzending gedaan in deze poll</p>
                <SignOut />
                </div>
            ) : (
                <div>
                    <Voting queryParam={queryParam} />
                </div>
            )}
        </div>
    );
}



export default App;
